import React from 'react';
import { AiFillStar } from 'react-icons/ai';
import { MdOutlineBoy, MdOutlineGirl } from 'react-icons/md';
import { testimonials } from '../../data/testimonials';

const TestimonialsSection = () => (
  <section id="testimonials" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <span className="inline-block mb-3 text-pink-600 font-medium">HAPPY CLIENTS</span>
        <h2 className="text-3xl sm:text-4xl font-bold font-serif text-gray-900 mb-4">What Our Customers Say</h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Don't just take our word for it - hear from our satisfied customers
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {testimonials.map((testimonial) => {
          const AvatarIcon = testimonial.gender === 'male' ? MdOutlineBoy : MdOutlineGirl;
          return (
          <div key={testimonial.name} className="bg-gray-50 p-8 rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 border border-transparent hover:border-pink-100">
            <div className="flex items-center mb-6">
              <div className="flex-shrink-0 mr-4">
                <div className={`h-14 w-14 rounded-2xl flex items-center justify-center ${testimonial.accent} text-white shadow-lg relative overflow-hidden`}>
                  <span className="absolute inset-0 bg-white/20 blur-lg" aria-hidden="true"></span>
                  <AvatarIcon className="relative z-10 h-7 w-7" />
                </div>
              </div>
              <div>
                <div className="flex items-center">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <AiFillStar key={i} className="text-yellow-400 w-5 h-5" />
                  ))}
                </div>
                <p className="text-sm text-gray-500 mt-1">{testimonial.date}</p>
              </div>
            </div>
            <blockquote className="text-gray-700 mb-6 italic relative pl-4">
              <div className="absolute left-0 top-0 h-full w-1 bg-pink-500 rounded-full"></div>
              "{testimonial.text}"
            </blockquote>
            <p className="font-semibold text-pink-600">— {testimonial.name}</p>
          </div>
        );
        })}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
